export type HideablePageId =
  | 'dashboard.resources'
  | 'dashboard.impact-dashboard'
  | 'dashboard.chat'
  | 'volunteering.activities'
  | 'volunteering.activity-report'
  | 'volunteering.incident-report'
  | 'management.dashboard'
  | 'management.activity-management'
  | 'management.rosters'
  | 'management.volunteers'
  | 'management.bulletins'
  | 'management.report-management'
  | 'management.incident-management'
  | 'management.program-management'
  | 'admin.tasks'
  | 'admin.forms'
  | 'admin.program-management'
  | 'admin.admin-console'
  | 'admin-console.admins'
  | 'admin-console.billing'
  | 'admin-console.security'
  | 'admin-console.onboarding'
  | 'admin-console.funnels'
  | 'admin-console.bulletins'
  | 'admin-console.resources'
  | 'admin-console.matching'
  | 'admin-console.labels'
  | 'admin-console.operations'
  | 'admin-console.reporting'
  | 'admin-console.tags'
  | 'admin-console.incident-reporting'
  | 'admin-console.roles'
  | 'admin-console.preferences'
  | 'admin-console.templates'
  | 'admin-console.reminders'
  | 'admin-console.notifications'
  | 'admin-console.chat'
  | 'admin-console.apps'
  | 'admin-console.embeddable-widgets';

export interface HideablePage {
  id: HideablePageId;
  label: string;
  group: string;
}

export const HIDEABLE_PAGES: HideablePage[] = [
  { id: 'dashboard.resources', label: 'Resources', group: 'Dashboard' },
  { id: 'dashboard.impact-dashboard', label: 'Impact Dashboard', group: 'Dashboard' },
  { id: 'dashboard.chat', label: 'Chat', group: 'Dashboard' },
  { id: 'volunteering.activities', label: 'Explore', group: 'Volunteering' },
  { id: 'volunteering.activity-report', label: 'Activity Report', group: 'Volunteering' },
  { id: 'volunteering.incident-report', label: 'Incident Report', group: 'Volunteering' },
  { id: 'management.dashboard', label: 'Dashboard', group: 'Management' },
  { id: 'management.activity-management', label: 'Activity Management', group: 'Management' },
  { id: 'management.rosters', label: 'Rosters', group: 'Management' },
  { id: 'management.volunteers', label: 'Volunteers', group: 'Management' },
  { id: 'management.bulletins', label: 'Bulletins', group: 'Management' },
  { id: 'management.report-management', label: 'Report Management', group: 'Management' },
  { id: 'management.incident-management', label: 'Incident Management', group: 'Management' },
  { id: 'management.program-management', label: 'Program Management (program managers)', group: 'Management' },
  { id: 'admin.tasks', label: 'Task Management', group: 'Admin' },
  { id: 'admin.forms', label: 'Forms & Surveys', group: 'Admin' },
  { id: 'admin.program-management', label: 'Program Management', group: 'Admin' },
  { id: 'admin.admin-console', label: 'Admin Console (whole console)', group: 'Admin' },
  { id: 'admin-console.admins', label: 'Admins', group: 'Admin Console: System' },
  { id: 'admin-console.billing', label: 'Billing', group: 'Admin Console: System' },
  { id: 'admin-console.security', label: 'Security', group: 'Admin Console: System' },
  { id: 'admin-console.onboarding', label: 'Onboarding', group: 'Admin Console: General' },
  { id: 'admin-console.funnels', label: 'Funnels', group: 'Admin Console: General' },
  { id: 'admin-console.bulletins', label: 'Bulletins', group: 'Admin Console: General' },
  { id: 'admin-console.resources', label: 'Resources', group: 'Admin Console: General' },
  { id: 'admin-console.matching', label: 'Application Actions', group: 'Admin Console: General' },
  { id: 'admin-console.labels', label: 'Custom Labels', group: 'Admin Console: General' },
  { id: 'admin-console.operations', label: 'Operations', group: 'Admin Console: Activities & Rosters' },
  { id: 'admin-console.reporting', label: 'Activity Reporting', group: 'Admin Console: Activities & Rosters' },
  { id: 'admin-console.tags', label: 'Tags', group: 'Admin Console: Activities & Rosters' },
  { id: 'admin-console.incident-reporting', label: 'Incident Reporting', group: 'Admin Console: Activities & Rosters' },
  { id: 'admin-console.roles', label: 'Roles', group: 'Admin Console: Activities & Rosters' },
  { id: 'admin-console.preferences', label: 'Preferences', group: 'Admin Console: Communications' },
  { id: 'admin-console.templates', label: 'Templates', group: 'Admin Console: Communications' },
  { id: 'admin-console.reminders', label: 'Reminders & Automations', group: 'Admin Console: Communications' },
  { id: 'admin-console.notifications', label: 'Notifications & Alerts', group: 'Admin Console: Communications' },
  { id: 'admin-console.chat', label: 'Chat', group: 'Admin Console: Communications' },
  { id: 'admin-console.apps', label: 'Apps', group: 'Admin Console: Integrations' },
  { id: 'admin-console.embeddable-widgets', label: 'Embeddable Widgets', group: 'Admin Console: Integrations' },
];

export const HIDEABLE_PAGE_GROUPS = HIDEABLE_PAGES.reduce<Array<{ group: string; pages: HideablePage[] }>>(
  (groups, page) => {
    const existing = groups.find((entry) => entry.group === page.group);
    if (existing) {
      existing.pages.push(page);
    } else {
      groups.push({ group: page.group, pages: [page] });
    }
    return groups;
  },
  []
);
